<div class="table-responsive">
    <table class="table table-striped table-borderless rounded-3 overflow-hidden" appAutoDataLabel>
        <thead>
        <tr>
            <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
        </tr>
        </thead>
        <tbody>
            @for (item of tableData(); track $index; ) {
                <tr>
                    <ng-container
                            *ngTemplateOutlet="bodyTemplate; context: { $implicit: item, index: $index, last: $last, first: $first }"></ng-container>
                </tr>
            }
        </tbody>
        <tfoot>
        <tr>
            <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
        </tr>
        </tfoot>
    </table>
</div>
